module.exports = __webpack_public_path__ + "static/media/oracledb.a2205912.png";